import { Location } from "reducers/newLocation.reducer";

export const getLocationsFromTree = (array: Location[]): Location[] => {
    return array.reduce((acc: Location[], i: Location) => {
        return i.children && i.children.length ? [...acc, ...getLocationsFromTree(i.children)] : [...acc, i];
    }, []);
};

export default getLocationsFromTree;
